
export const amounttaxesdata = [
  { name: "TTC", id: "ttc"},
  { name: "HTVA", id: "htva"},
];

export const energyData = [
  { name: "Electricité", id: "electricity" },
  { name: "Gaz", id: "gas" },
  { name: "Eau", id: "water" },
  { name: "Chaleur", id: "heat" },
  { name: "Froid", id: "cold" },
  { name: "Propane", id: "propane" },
  { name: "Fioul", id: "fuel" },
  { name: "Bois", id: "wood" },
];
